import {
  UPDATE_LOADING,
  UPDATE_DIRECTION,
  UPDATE_BACK_PATH,
  UPDATE_PAGE_FROM,
  JUMP_LOGIN,
  // SET_OS,
  UPDATE_IS_USED_LISTBUTTON,
  UPDATE_BANNER_LIST,
  UPDATE_INNERHEIGHT,
  UPDATE_TIPS_ADD_SITE,
  UPDATE_ENTERPRISE_ID
} from '../mutation-types'

const state = {
  banner_list: [],
  is_loading: false, // 是否开启加载动画
  direction: 'forward',
  back_path: null, // 后退键地址
  server_phone: '4008-520-084',
  page_from: null,
  is_weixin_browser: /micromessenger/.test(navigator.userAgent.toLowerCase()),
  isiOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
  is_android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
  is_used_listButton: window.localStorage.getItem('listButtonShow') === null ? 'firstUsed' : 'noFirst',
  qiyu_group_id: '304059',
  innerHeight: window.innerHeight,
  qiyu_staff_id: '106250', // 帧帧
  reload_page: false,
  tips_add_site: window.localStorage.getItem('cache_tips_add_site') || '',
  enterprise_id: ''
}

const mutations = {
  [UPDATE_LOADING] (state, is_loading) {
    state.is_loading = is_loading
  },
  [UPDATE_DIRECTION] (state, direction) {
    state.direction = direction
  },
  [UPDATE_BACK_PATH] (state, back_path) {
    state.back_path = back_path
  },
  [JUMP_LOGIN] (state, self) {
    self.$router.push('/login')
  },
  [UPDATE_PAGE_FROM] (state, path) {
    state.page_from = path
  },
  // [SET_OS] (state, val) {
  //   state.os = val
  // },
  [UPDATE_IS_USED_LISTBUTTON] (state, val) {
    state.is_used_listButton = val
  },
  [UPDATE_BANNER_LIST] (state, data) {
    state.banner_list = data
  },
  [UPDATE_INNERHEIGHT] (state, data) {
    state.innerHeight = data
  },
  [UPDATE_TIPS_ADD_SITE] (state, val) {
    state.tips_add_site = val
    window.localStorage.setItem('cache_tips_add_site', 'showed')
  },
  [UPDATE_ENTERPRISE_ID] (state, val) {
    state.enterprise_id = val
    // 设置缓存
    window.localStorage.setItem('cache_enterprise_id', val + '')
  }
}

const actions = {
  setLoading ({ commit }, val) {
    commit('UPDATE_LOADING', val)
  },
  changeHeight ({ commit }, val) {
    commit('UPDATE_INNERHEIGHT', window.innerHeight)
  },
  setTipsAddSite ({ commit }, val) {
    commit('UPDATE_TIPS_ADD_SITE', val)
  },
  setEnterprise ({ commit }, val) {
    commit('UPDATE_ENTERPRISE_ID', val)
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js